"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProduction = exports.findIdentified = exports.findOperator = exports.forEachOperator = void 0;
const tslib_1 = require("tslib");
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const has_1 = tslib_1.__importDefault(require("lodash/has"));
const forEach_1 = tslib_1.__importDefault(require("lodash/forEach"));
const constants_1 = require("../../constants");
// WARNING: be careful with these functions as you shouldn't typically need to use them.
// Aggregations can (and should) be built in pure functions that depend _only_ on provided arguments.
// There should be no need to "find" an operator or loop through a pipeline
// because you should know what operators are in your aggregation by looking at
// the parameters you passed to your pure agg-building function.
// There are a few scenarios (like with guide audience pipelines) where the agg has been
// pre-compiled and we don't have all the necessary information we need to make a decision.
// There are bugs in old audience pipelines that we need to explicitly handle by looking at
// the operators in a guide audience.
function forEachOperator(pipeline, callback) {
    walkPipeline(pipeline, callback, true);
}
exports.forEachOperator = forEachOperator;
function findOperator(pipeline, predicate) {
    let operator;
    forEachOperator(pipeline, o => {
        if (predicate(o)) {
            operator = o;
            return false;
        }
    });
    return operator;
}
exports.findOperator = findOperator;
function findIdentified(pipeline) {
    return findOperator(pipeline, operator => operator.identified);
}
exports.findIdentified = findIdentified;
function getNestedPipeline(operator) {
    if ((0, has_1.default)(operator, 'spawn')) {
        return operator.spawn;
    }
    if ((0, has_1.default)(operator, 'fork')) {
        return operator.fork;
    }
    if ((0, has_1.default)(operator, 'merge')) {
        return operator.merge.pipeline;
    }
}
// `_continue` lets you exit the walk early when the `callback` explicitly returns `false`
function walkPipeline(pipeline, callback, _continue = true) {
    if (_continue === false)
        return _continue;
    (0, forEach_1.default)(pipeline, (operator, i) => {
        // spawns/forks contain an array of pipelines
        if ((0, isArray_1.default)(operator)) {
            _continue = walkPipeline(operator, callback, _continue);
        }
        else {
            _continue = callback(operator, pipeline, i);
            _continue = walkPipeline(getNestedPipeline(operator), callback, _continue);
        }
        return _continue;
    });
    return _continue;
}
function isProduction() {
    return window[Symbol.for('AggConnectSetup')].env === constants_1.Environment.PROD;
}
exports.isProduction = isProduction;
